function TermsAndConditions({ goBack }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
        padding: "30px"
      }}
    >
      <button
        onClick={goBack}
        style={{
          padding: "12px 22px",
          border: "none",
          borderRadius: "10px",
          cursor: "pointer",
          fontWeight: "bold",
          backgroundColor: "#ffd600"
        }}
      >
        ⬅ Back
      </button>

      <div
        style={{
          maxWidth: "1000px",
          margin: "25px auto",
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "25px",
          boxShadow:
            "0 8px 25px rgba(0,0,0,0.35)",
          lineHeight: "1.9"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "45px",
            color: "#000"
          }}
        >
          📜 Terms & Conditions
        </h1>

        <p
          style={{
            textAlign: "center",
            color: "#555",
            fontSize: "18px"
          }}
        >
          Please read these terms carefully before using
          MNHouseFinder.
        </p>

        <hr />

        <h2>1. Purpose of MNHouseFinder</h2>

        <p>
          MNHouseFinder is a digital platform that
          connects:
        </p>

        <ul>
          <li>🏠 Tenants searching for homes.</li>

          <li>🏢 Landlords advertising properties.</li>

          <li>
            🏬 Owners advertising commercial spaces.
          </li>

          <li>
            🏢 Businesses searching for office spaces.
          </li>
        </ul>

        <h2>2. User Responsibilities</h2>

        <p>Users agree to:</p>

        <ul>
          <li>
            ✔ Provide accurate information.
          </li>

          <li>
            ✔ Use genuine phone numbers.
          </li>

          <li>
            ✔ Respect other users.
          </li>

          <li>
            ✔ Keep account credentials secure.
          </li>

          <li>
            ✔ Use the platform lawfully.
          </li>
        </ul>

        <h2>3. Prohibited Activities</h2>

        <p>Users must not:</p>

        <ul>
          <li>
            ❌ Upload fake properties.
          </li>

          <li>
            ❌ Upload stolen properties.
          </li>

          <li>
            ❌ Impersonate another person.
          </li>

          <li>
            ❌ Harass other users.
          </li>

          <li>
            ❌ Attempt to hack the platform.
          </li>

          <li>
            ❌ Share misleading information.
          </li>
        </ul>

        <h2>4. Property Verification</h2>

        <p>
          MNHouseFinder provides a connection
          between parties but does not guarantee
          ownership, availability, legality,
          pricing or property condition.
        </p>

        <p>
          Users should physically verify any
          property before making payments.
        </p>

        <h2>5. Payments Disclaimer</h2>

        <p>
          Never send money without confirming
          ownership and viewing the property.
        </p>

        <p>
          MNHouseFinder is not responsible for
          losses resulting from private
          transactions between users.
        </p>

        <h2>6. Privacy & Data Usage</h2>

        <p>
          Information collected may include:
        </p>

        <ul>
          <li>Names</li>

          <li>Phone numbers</li>

          <li>Email addresses</li>

          <li>Property information</li>

          <li>Location information</li>
        </ul>

        <p>
          We use this information only to
          improve services and connect users.
        </p>

        <h2>7. Account Suspension</h2>

        <p>
          MNHouseFinder shall suspend or
          permanently remove accounts that:
        </p>

        <ul>
          <li>Spread false information.</li>

          <li>Conduct scams.</li>

          <li>Violate these terms.</li>

          <li>Abuse other users.</li>
        </ul>

        <h2>8. Intellectual Property</h2>

        <p>
          The MNHouseFinder name, branding,
          designs and software belong to
          MNHouseFinder.
        </p>

        <p>
          Users shall not copy, reproduce or
          redistribute any part of the platform
          without permission.
        </p>

        <h2>9. Limitation of Liability</h2>

        <p>
          MNHouseFinder is a marketplace and
          shall not be held liable for:
        </p>

        <ul>
          <li>Property disputes.</li>

          <li>Rental disagreements.</li>

          <li>Fraudulent activities.</li>

          <li>Financial losses.</li>

          <li>Damages from third parties.</li>
        </ul>

        <h2>10. Changes to Terms</h2>

        <p>
          These terms may be updated from
          time to time to improve security,
          services and user experience.
        </p>

        <h2>11. Contact Information</h2>

        <p>
          📞 0745 746 190
        </p>

        <p>
          📞 0798 061 862
        </p>

        <p>
          📧 supportmnhousefinder@gmail.com
        </p>

        <hr />

        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "18px"
          }}
        >
          © {new Date().getFullYear()}
          {" "}
          MNHouseFinder. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default TermsAndConditions;